<header class="prom-empty-header {logoClass}"></header>

<script>
    /** @type {'itsl'|'fronter'} */
    export let logo = 'itsl';

    $: logoClass = `prom-empty-header--${logo}`;
</script>
